import { render } from "./Hotspot13.vue?vue&type=template&id=62e35e58&scoped=true&ts=true"
import script from "./Hotspot13.vue?vue&type=script&lang=ts"
export * from "./Hotspot13.vue?vue&type=script&lang=ts"

import "./Hotspot13.vue?vue&type=style&index=0&id=62e35e58&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e35e58"]])

export default __exports__